import * as Yup from 'yup';

export const paymentValidation = {
    customerId: Yup.string().trim()
        .required("Please Select Customer"),
    amount: Yup.string().trim()
        .required("Please enter amount")
        .matches(/^\d{1,10}$/, 'Please enter valid number.'),
}